import { render, staticRenderFns } from "./AdminDataTable.vue?vue&type=template&id=04174f74&scoped=true"
import script from "./AdminDataTable.vue?vue&type=script&lang=ts"
export * from "./AdminDataTable.vue?vue&type=script&lang=ts"
import style0 from "./AdminDataTable.vue?vue&type=style&index=0&id=04174f74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04174f74",
  null
  
)

export default component.exports